export const path = {
  LANDING: '/',
  SIGNIN: '/signin',
  SIGNUP: '/signup',
  ACCOUNTSETUP: '/account-setup',
  ADMINSUPPLIER: '/admin-supplier',
  USERPROFILEFORM: '/profile-form',
  UPDATEPROFILE: '/update-profile',
  REGISTER: '/register',
  FILE_UPLOAD: '/file-upload',
  NETWORK_ERROR: '/network-error',
  VALIDATE_EMAIL: '/validate-email',
  MARKET: '/marketplace',
  ABOUT: '/about',
  CONTACT: '/contact',
  BLOG: '/blog',
  ALLARTICLES: '/blog/all-articles',
  INTERNATIONALTRADE: '/blog/international-trade',
  STORAGE: '/blog/storage',
  CULTIVATION: '/blog/cultivation',
  HERBSANDSPICES: '/herbs-and-spices',
  FRUITS: '/fruits',
  VEGETABLES: '/vegetables',
  NUTS: '/nuts',
  GRAINS: '/grains',
  LEGUMES: '/legumes',
  TUBERS: '/tubers',
  BEVERAGES: '/beverages',
  ALLPRODUCTS: '/all-products',
  SUPPLIERS: '/suppliers',
  TERREBASICS: '/terre-basics',
  PRODUCTDETAIL: '/product-detail',
  TERMS_OF_SERVICE: '/terms-of-service'
}
